import { GET_CUSTOMIZE_COLUMNS_ORDER, GET_CUSTOMIZE_COLUMNS_ORDER_ERROR, GET_CUSTOMIZE_COLUMNS_ORDER_SUCCESS, UPDATE_CUSTOMIZE_COLUMNS_ORDER, UPDATE_CUSTOMIZE_COLUMNS_ORDER_ERROR, UPDATE_CUSTOMIZE_COLUMNS_ORDER_SUCCESS } from "./actionTypes"

export const getCustomizeColumnsOrder = (page_name) => {
    return (
        {
            type: GET_CUSTOMIZE_COLUMNS_ORDER,
            payload: page_name
        }
    )
}

export const getCustomizeColumnsOrderSuccess = (columns_order) => {
    return (
        {
            type: GET_CUSTOMIZE_COLUMNS_ORDER_SUCCESS,
            payload: columns_order
        }
    )
}

export const getCustomizeColumnsOrderError = (error) => {
    return (
        {
            type: GET_CUSTOMIZE_COLUMNS_ORDER_ERROR,
            payload: error
        }
    )
}


export const updateCustomizeColumnsOrder = (columns_order) => {
    return (
        {
            type: UPDATE_CUSTOMIZE_COLUMNS_ORDER,
            payload: columns_order
        }
    )
}

export const updateCustomizeColumnsOrderSuccess = (columns_order) => {
    return (
        {
            type: UPDATE_CUSTOMIZE_COLUMNS_ORDER_SUCCESS,
            payload: columns_order
        }
    )
}

export const updateCustomizeColumnsOrderError = (error) => {
    return (
        {
            type: UPDATE_CUSTOMIZE_COLUMNS_ORDER_ERROR,
            payload: error
        }
    )

}